export const getUserRoleEndpoint="api/v1/user/details";
export const getSupplierDropdownListEndpoint="api/v1/user/supplier/mapping";
export const getSupplierFilterDropdownEndpoint="api/v1/supplier/forecast/filter-data";
export const postInviteSupplierEndpoint="api/v1/user/supplier/invite";
export const getAdminSupplierUserListEndpoint="api/v1/user/supplier";
export const getEmailDomainListEndpoint="api/v1/user/supplier/mapping/domain";
export const getSupplierForecastTableEndpoint="api/v1/supplier/forecast";
export const getSupplierForecastSearchTableEndpoint="api/v1/supplier/forecast/filter-search"
export const getForecastHistoryTableEndpoint="api/v1/supplier/forecast/history"
export const getSupplierForecastSaveDataEndpoint="api/v1/supplier/forecast/override"
export const hiddenColumnsEndpoint="api/v1/user/hidden-columns"
export const fileUploadSupplierEndpoint="api/v1/supplier/forecast/override/upload";
export const fileUploadBuyerEndpoint="api/v1/buyer/forecast/override/upload";
export const getReasonCodeEndpoint="api/v1/forecast/reason-code"
export const putEditReasonCodeEndpoint="api/v1/forecast/reason-code"
export const postReasonCodeEndpoint="api/v1/forecast/reason-code"
export const deleteReasonCodeEndpoint="api/v1/forecast/reason-code"
export const getBuyerDropdownFilterEndpoint="api/v1/buyer/forecast/filter-data"
export const getBuyerForecastTableEndpoint="api/v1/buyer/forecast"
export const getBuyerForecastSearchTableEndpoint="api/v1/buyer/forecast/filter-search"
export const getBuyerForecastSaveDataEndpoint="api/v1/buyer/forecast/override"
export const submitBuyerForecastOverrideDataEndpoint="api/v1/buyer/forecast/override/confirm"
export const getPOExceptionMgmtBuyerTableEndpoint="api/v1/poManagement/search"
export const getPOExceptionMgmtBuyerTablefilterEndpoint="/api/v1/poManagement/filters"
export const getMaterialBatchDataEndpoint="api/v1/poManagement/materialBatchDetails"
export const getPlantRegionDetailsEndpoint="api/v1/buyer/forecast/plants-regions-filter"
export const getSupplierEmailsEndpoint="api/v1/poManagement/getSupplierEmails"
export const addToSupplierEmailsEndpoint="api/v1/poManagement/addToSupplierEmails"
export const sendMailToSupplierEndpoint="api/v1/poManagement/sendMailToSupplier"
export const sendToSupplierEndpoint="api/v1/poManagement/sendToSupplier"
export const getSupplierPortalDataEndpoint="api/v1/poSupplierPortal/getSupplierData"
export const updateUserResponseEndpoint="api/v1/poSupplierPortal/updateUserResponse"
export const updateCollabStatusEndpoint="api/v1/poManagement/updateCollabStatus"
export const viewParticularAnnouncementEndpoint="api/announcements/posted-by-user"
export const viewAllAnnouncementEndpoint="api/announcements/posted-by-user"
export const viewSupplierAnnouncementEndpoint="api/announcements"
export const postAnnouncementEndpoint="api/announcements/publish"
export const getUnreadAnnouncementCountEndpoint="api/announcements/unread/count"
export const postUnreadAnnouncementCountEndpoint="api/announcements"
export const addAppAdminTrainingContentEndpoint="api/v1/training/content/addTopic"
export const updateAppAdminTrainingContentEndpoint="api/v1/training/content/updateTopic"
export const deleteAppAdminTrainingContentEndpoint="api/v1/training/content/deleteTopic"
export const getAppAdminTrainingContentEndpoint="api/v1/training/content/getAllTopics"